import { DeviceType } from '@/src/types/deviceType'
import { getAppAgent } from '@/src/utils/deviceType'
import { isEmpty } from '@/src/utils/generalUtils/isEmpty'
import { logError } from '@/src/utils/logError'
import { getCurrentLocale } from '@/src/utils/rtkQuery/getCurrentLocale'
import axios from 'axios'

export const apiGetHelper = async ({
    URL = '',
    contentType = '',
    requestHeaders = {},
    deviceType
}: {
    URL: string
    contentType?: string
    requestHeaders?: object
    deviceType: DeviceType
}) => {
    try {
        let contentTypeText = 'application/json; charset=UTF-8, text/html'
        const locale = getCurrentLocale()
        if (contentType) {
            contentTypeText = contentType
        }
        const appAgent = deviceType ? getAppAgent(deviceType) : 'N/A'
        let headers = {
            Accept: 'application/json',
            'Content-Type': contentTypeText,
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0',
            X_CT_SOURCETYPE: 'MOBILE',
            'app-agent': appAgent,
            'Preferred-Language': locale
        }
        if (typeof window !== 'undefined') {
            headers = { ...headers, ...window.androidData, ...window.iosData }
        }
        if (!isEmpty(requestHeaders)) {
            headers = {
                ...headers,
                ...requestHeaders
            }
        }
        const responseData = await axios.get(URL, {
            headers
        })
        return responseData
    } catch (e) {
        logError('apiGetHelper', e)
        return e
    }
}
